// src/firebase1.ts (Oyun 1)
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyAqSfNzZrZehHyMKI0pu2UnAiJpyYejJNI",
    authDomain: "trezzure-a31ef.firebaseapp.com",
    projectId: "trezzure-a31ef",
    storageBucket: "trezzure-a31ef.firebasestorage.app",
    messagingSenderId: "533307054669",
    appId: "1:533307054669:web:742cacfe7999f0fccf9a04",
};

const app = initializeApp(firebaseConfig, "trezzure"); // Her oyun için benzersiz bir isim
export const db1 = getFirestore(app);